import { render, staticRenderFns } from "./SelectQuantities.vue?vue&type=template&id=2952bdbc&"
import script from "./SelectQuantities.vue?vue&type=script&lang=ts&"
export * from "./SelectQuantities.vue?vue&type=script&lang=ts&"
import style0 from "./SelectQuantities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports